import {logoNewSabin, SSMFirstSlideFollowButton, SSMFirstSlideMobileBg, SSMScrollPeek} from "../../../../assets";
import s from "./firstSlide.module.css";
import {useFirstSlide} from "./useFirstSlide";

const FirstSlide = (props) => {
    // Destructured props
    const {
        selfServiceAttendanceModalData,
        currentSlide,
        handleCurrentSlide
    } = props;

    // Component logic data
    const componentProps = useFirstSlide({});

    // Destructured component logic data
    const {
        CTAs,
        currentCta,
    } = componentProps;

    const CTAElements = CTAs.map((item, index) => (
        <p
            key={item}
            className={`text-sabin-red-default ${currentCta === index ? s.ctaAnimation : s.ctaFadeOutAnimation}`}
        >
            {item}
        </p>
    ))

    return (
        <div className={`container-fluid h-full ${s.root}`}>
            {/* Dummy element */}
            <div className={`!hidden ${s.ctaAnimation} ${s.ctaFadeOutAnimation}`} />

            {/* Backdrop */}
            <div className={`w-full h-full absolute top-0 left-0 z-10 pointer-events-none transition-all duration-300 bg-black ${currentSlide > 1 ? "opacity-75" : "opacity-0"}`} />

            <div className={`sabin-container h-full flex flex-col items-start justify-between xs:justify-center gap-y-3.5 xs:gap-y-14 relative z-0 !pt-4 xs:!pt-0 !pb-14 xs:!pb-0`}>
                <img
                    src={logoNewSabin}
                    alt="Store logo"
                    className={`${s.logo}`}
                />
                <div className={`h-full xs:h-auto w-full flex flex-col items-start gap-y-6 xs:gap-y-14`}>
                    <img
                        src={SSMFirstSlideMobileBg}
                        className={`justify-self-center w-[70%] self-center xs:hidden`}
                        alt="Background image"
                    />

                    <div className={`flex flex-col justify-between gap-y-3.5 xs:gap-y-5 w-full xs:mt-0`}>
                        <h2 className={`${s.heading}`}>
                            {selfServiceAttendanceModalData?.initialTitle || `Chegou a unidade digital Sabin!`}
                        </h2>
                        <div className={`flex flex-row gap-x-4 flex-wrap gap-y-1`}>
                            <div className={`${s.redDash} w-[162px]`} />
                            <div className={`${s.redDash} w-[22px]`} />
                            <div className={`${s.redDash} w-[66px]`} />
                        </div>
                        <h1 className={`${s.cta}`}>
                            Mais&nbsp;
                            {CTAElements}
                        </h1>
                    </div>
                    <button
                        type="button"
                        className={`${s.followButton}`}
                        onClick={() => handleCurrentSlide()}
                    >
                        <div className={`relative z-0 w-full xs:w-auto`}>
                            <img
                                src={SSMFirstSlideFollowButton}
                                alt="Follow button"
                                className={`w-full xs:w-auto`}
                            />
                            <img
                                src={SSMScrollPeek}
                                alt="Scroll peek"
                                className={`${s.scrollPeekGif}`}
                            />
                        </div>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default FirstSlide;
